import { useEffect, useState } from 'react'
import Pagination from '../components/commons/Pagination'
import { getAllCategories, getCategoryById } from '../firebase/categories'
import { formatDate } from '../utils'
import DialogCreateCategory from '../components/dialogs/DialogCreateCategory'
import { useAtom } from 'jotai'
import { showCreateCategoryModalAtom, showManageCategoryModalAtom } from '../store'
import DialogManageCategory from '../components/dialogs/DialogManageCategory'
import { getAllListings, getListingsByCategories, getSalesByCategories, updateListing } from '../firebase/listings'
import { Link } from 'react-router-dom'
import DialogSuccess from '../components/dialogs/DialogSuccess'
import DialogDelete from '../components/dialogs/DialogDelete'
import DialogDeclineListing from '../components/dialogs/DialogDeclineListing'
import { useAuth } from '../context/authContext'
import { toast } from 'react-toastify'

const ListingItem = ({ listing, onUpdate, currentUserId }) => {
    const [listingsCount, setListingsCount] = useState(0)
    const [salesCount, setSalesCount] = useState(0)
    const [category, setCategory] = useState('')
    const [showApproveModal, setShowApproveModal] = useState(false)
    const [showDeclineModal, setShowDeclineModal] = useState(false)
    const [showApproveSuccessModal, setShowApproveSuccessModal] = useState(false)
    const [showDeclineSuccessModal, setShowDeclineSuccessModal] = useState(false)

    useEffect(() => {
        getCategoryById(listing.category).then(cat => {
            setCategory(cat)
        })
    }, [])

    const handleApproveListing = async () => {
        await updateListing({ 
            listingId: listing.id, 
            state: 'approved',
            adminUserId: currentUserId
        })
        setShowApproveSuccessModal(true)
        setShowApproveModal(false)
    }

    const handleDeclineListing = async (declineReason) => {
        console.log("=== HANDLE DECLINE LISTING ===")
        console.log("Listing ID:", listing.id)
        console.log("Decline reason:", declineReason)
        console.log("Current user ID:", currentUserId)
        
        try {
            await updateListing({ 
                listingId: listing.id, 
                state: 'declined',
                declined_reason: declineReason,
                adminUserId: currentUserId
            })
            console.log("updateListing completed successfully")
            setShowDeclineSuccessModal(true)
            setShowDeclineModal(false)
        } catch (error) {
            console.error("Error in handleDeclineListing:", error)
        }
    }

    return (
        <>
            <DialogSuccess
                message="Listing is successfully added"
                open={showApproveSuccessModal}
                onClose={() => {
                    setShowApproveSuccessModal(false),
                        onUpdate()
                }}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
                buttonLink='/listing'
            />

            <DialogDelete
                message="Are you sure you want to approve listing?"
                open={showApproveModal}
                onClose={() => setShowApproveModal(false)}
                buttonText="Approve"
                onButtonClick={handleApproveListing}
                title="Approve Listing?"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
            />

            <DialogSuccess
                message="Listing is successfully declined"
                open={showDeclineSuccessModal}
                onClose={() => {
                    setShowDeclineSuccessModal(false),
                        onUpdate()
                }}
                buttonText="Back to Dashboard"
                title="Success"
                iconSrc="/assets/icons/icon-check-white-circle.svg"
                type="confirm"
                buttonLink='/listing'
            />

            <DialogDeclineListing
                open={showDeclineModal}
                onClose={() => setShowDeclineModal(false)}
                onDecline={handleDeclineListing}
                listingTitle={listing.title}
            />

            <tr key={listing.id} className='h-[70px] hover:bg-[#2F2F2F] p-2'>
                <td className='w-[100px] pl-2'>
                    <img alt='picture' src={listing.pictures[0]} className='w-[55px] h-[55px] object-cover' />
                </td>

                <td className='uppercase xl:w-[300px]'>
                    {listing.title}
                </td>

                <td className='xl:w-[300px]'>
                    {category.name}
                </td>

                <td className='xl:w-[300px]'>
                    {listing.created_at ? formatDate(listing.created_at.seconds) : 'N/A'}
                </td>

                <td className='xl:w-[200px]'>
                    ${listing.price.toFixed(2)}
                </td>

                <td className='xl:w-[150px]'>
                    {listing.source === 'shopify' || listing.shopify_product_id ? 'Shopify' : ''}
                </td>

                <td>
                    <div className='flex items-center  justify-between'>
                        <Link to={`/marketplace/${listing.id}`} className='text-primary underline mr-8'>
                            Listings Details
                        </Link>

                        <div className='flex pr-3'>
                            <button className="px-6 py-2 bg-white text-black rounded-[33px] mr-2" onClick={() => setShowApproveModal(true)}>
                                Approve
                            </button>

                            <button className="px-6 py-2 bg-white text-black rounded-[33px]" onClick={() => setShowDeclineModal(true)}>
                                Decline
                            </button>
                        </div>
                    </div>
                </td>
            </tr>
        </>
    )
}

const ListingManagement = () => {
    const [currentPage, setCurrentPage] = useState(1)
    const [listings, setListings] = useState(null)
    const [loading, setLoading] = useState(true)
    const [updatedTimes, setUpdatedTimes] = useState(0)
    const [showCreateCategoryModal, setShowCreateCategoryModal] = useAtom(showCreateCategoryModalAtom)
    const [showManageCategoryModal, setShowManageCategoryModal] = useAtom(showManageCategoryModalAtom)
    const [selectedCategory, setSelectedCategory] = useState(null)
    const fields = ["", "Listing title", 'Category name', 'Date added', 'Price', 'Source', 'Other']
    const { user } = useAuth()

    useEffect(() => {
        updateListings()
    }, [showCreateCategoryModal, showManageCategoryModal])

    const updateListings = () => {
        getAllListings('pending').then((cats) => {
            setListings(cats)
            setLoading(false)
        })

        setUpdatedTimes(updatedTimes + 1)
    }

    const handleManageCategory = (cat) => {
        setSelectedCategory(cat)
        setShowManageCategoryModal(true)
    }

    return (
        <>
            <DialogCreateCategory
                open={showCreateCategoryModal}
                onClose={() => setShowCreateCategoryModal(false)}
            />

            {
                selectedCategory &&
                <DialogManageCategory
                    open={showManageCategoryModal}
                    category={selectedCategory}
                    onClose={() => setShowManageCategoryModal(false)}
                />
            }



            <div className="px-10 py-8">
                <div className="flex items-center justify-between">
                    <h1 className="text-primary text-[36px]">Listing Manager</h1>

                    <div className="flex items-center gap-3">
                        <div className="px-6 py-2 bg-[#1F1F1F] rounded-[33px] min-w-[164px] text-[#666] text-center" >{listings ? listings.length : 0} Pending Listings</div>
                    </div>
                </div>
                
                {loading ? (
                    <div className="my-10">
                        <div className="flex items-center justify-center h-64">
                            <div className="flex flex-col items-center">
                                <img src="/assets/icons/icon-loading.svg" alt="loading" className="w-8 h-8 animate-spin mb-4" />
                                <p className="text-white text-lg">Loading listings...</p>
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        <div className="my-10">
                            <div className="w-full overflow-auto">

                                {
                                    listings.length > 0 ?
                                        <table className="w-full">
                                            <thead>
                                                <tr className="bg-[#2E2E2E] rounded-[4px] py-3 text-sm text-[#717171]">
                                                    {
                                                        fields.map((item, index) =>
                                                            <th className={`py-3 text-left ${index > 0 ? '' : 'pl-3'}`} key={`offer-field-${item}-${index}`}>
                                                                {item}
                                                            </th>
                                                        )
                                                    }
                                                </tr>
                                            </thead>
                                            <tbody className="text-white space-y-1 text-sm">
                                                {
                                                    listings.slice(8 * (currentPage - 1), 8 * currentPage).map(listing =>
                                                        <ListingItem 
                                                            key={listing.id} 
                                                            listing={listing} 
                                                            handleManageCategory={handleManageCategory} 
                                                            onUpdate={updateListings}
                                                            currentUserId={user?.uid}
                                                        />
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                        :
                                        <div className="text-white text-lg text-center mt-8 w-full">
                                            No pending listings
                                        </div>
                                }
                            </div>
                        </div>

                        <div className="mt-auto">
                            <Pagination itemsPerPage={8} totalItems={listings.length} onPageChange={(v) => { setCurrentPage(v) }} />
                        </div>
                    </>
                )}
            </div>
        </>
    )
}

export default ListingManagement